import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ViewWorkshopJobStoreService } from './view-workshop-job-store.service';
import { WorkshopJobService } from '../../shared/services/workshop-job.service';
import { CustomerService } from '../../shared';
import { WorkshopJobEventsService } from '../../shared/services/workshop-job-events.service';
import { RepairDocketService } from '../../shared/services/repair-docket.service';
import { filter, map, startWith } from 'rxjs/operators';
import { WORKSHOP } from '../../../testIds';
import { ItemAttributesService } from '../../shared/services/item-attributes.service';
import { WorkshopJobTemplateService } from 'src/app/shared/services/workshop-job-template.service';
import { CustomerAddressPipe } from '../../shared/pipes/customer-address.pipe';
import { CustomerContactDetailsPipe } from '../../shared/pipes/customer-contact-details.pipe';
import { CustomerNamePipe } from '../../shared/pipes/customer-name.pipe';
import { PartsListComponent } from './parts-list/parts-list.component';
import { WorkshopJobEventComponent } from './workshop-job-event/workshop-job-event.component';
import { AddEventButtonsComponent } from './add-event-buttons/add-event-buttons.component';
import { JobSettingsComponent } from './job-settings/job-settings.component';
import { MatTooltip } from '@angular/material/tooltip';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TrackedAttributesPromptComponent } from '../../shared/item-attributes/tracked-attributes-prompt/tracked-attributes-prompt.component';
import { WorkshopJobDetailsComponent } from './workshop-job-details/workshop-job-details.component';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { MatCard, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'app-view-workshop-job',
    templateUrl: './view-workshop-job.component.html',
    providers: [
        ViewWorkshopJobStoreService,
        WorkshopJobService,
        CustomerService,
        WorkshopJobEventsService,
        RepairDocketService,
        ItemAttributesService,
        WorkshopJobTemplateService
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatCard, MatCardContent, NgIf, WorkshopJobDetailsComponent, TrackedAttributesPromptComponent, NgxSkeletonLoaderModule, MatTooltip, RouterLink, JobSettingsComponent, AddEventButtonsComponent, NgFor, WorkshopJobEventComponent, PartsListComponent, AsyncPipe, CustomerNamePipe, CustomerContactDetailsPipe, CustomerAddressPipe]
})
export class ViewWorkshopJobComponent {
  testIds = WORKSHOP;
  job$ = this.store.job$;
  templateName$ = this.store.template$.pipe(map((template) => template?.name));
  customer$ = this.store.customer$;
  loading$ = this.store.loading$;
  customerLoading$ = this.store.customerLoading$;
  events$ = this.store.eventsOrdered$;
  repairDocket$ = this.store.repairDocket$;
  attributes$ = this.store.attributes$;
  docketFinalized$ = this.store.repairDocket$.pipe(
    filter(Boolean),
    map((docket) => docket.finalized_at),
    map(Boolean),
    startWith(false)
  );

  constructor(
    private route: ActivatedRoute,
    private store: ViewWorkshopJobStoreService
  ) {
    this.route.params.subscribe((params) => {
      this.store.loadJob(params.id);
    });
  }

  clearAttributes() {
    this.store.clearAttributes();
  }
}
